import { render, staticRenderFns } from "./PengajuanUangMakan.vue?vue&type=template&id=2cd66d7a"
import script from "./PengajuanUangMakan.vue?vue&type=script&lang=js"
export * from "./PengajuanUangMakan.vue?vue&type=script&lang=js"
import style0 from "./PengajuanUangMakan.vue?vue&type=style&index=0&id=2cd66d7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports